module.exports = __webpack_public_path__ + "static/media/10.fd35dd1c.jpg";